import { gql } from 'graphql-request';

export const getCreatedInvoices = gql`
  query listWA_CreatedInvoices($filter: WA_CreatedInvoicesGridFilter!) {
    wawiAssist {
      listWA_CreatedInvoices(filter: $filter) {
        invoiceId
        invoiceDate
        invoiceNo
        invoiceTotal
        isDeleted
        customerId
        customerNo
        internalOrFullName
        isEmailService
        isAutoBankDebit
        isExported
      }
    }
  }
`;

export const validateSepaWA_Invoices = gql`
  query ValidateSepaWA_Invoices($invoiceIds: [ID!]!) {
    wawiAssist {
      validateSepaWA_Invoices(invoiceIds: $invoiceIds) {
        hasConfigErrors
        hasInvalidCustomers
        invalidCustomers {
          customerId
          customerNo
          internalOrFullName
        }
        configErrors {
          creditorIdNumber
          bankBIC
          bankIBAN
          name
        }
      }
    }
  }
`;

export const exportSepaWA_Invoices = gql`
  mutation ExportSepaWA_Invoices($params: WA_ExportSepaInvoicesInputs!) {
    wawiAssist {
      exportSepaWA_Invoices(params: $params) {
        files {
          fileName
          url
        }
      }
    }
  }
`;

export const printInvoiceReports = gql`
  mutation PrintWA_InvoiceReports($invoicesIds: [ID!]!) {
    wawiAssist {
      printWA_InvoiceReports(invoicesIds: $invoicesIds) {
        countCreated
        countErrors
      }
    }
  }
`;

export const getOrderPositionsForCreatedInvoice = gql`
  query getOrderPositionsForCreatedInvoice($orderId: ID!, $isInvoiceDeleted: Boolean!) {
    wawiAssist {
      listWA_OrderPositionsForCreatedInvoice(
        orderId: $orderId
        isInvoiceDeleted: $isInvoiceDeleted
      ) {
        orderPositionId
        virtualPositionId
        articleNo
        articleName
        quantity
        price
        total
        discount
        taxName
        weight
        indTextDeliveryNote
      }
    }
  }
`;

export const getOrdersForCreatedInvoice = gql`
  query getOrdersForCreatedInvoice($id: ID!) {
    wawiAssist {
      listWA_OrdersForCreatedInvoice(invoiceId: $id) {
        orderId
        orderDate
        orderNo
        orderTotal
        customerId
        customerNo
        internalOrFullName
      }
    }
  }
`;

export const getInvoiceDeletingInfo = gql`
  query GetWA_InvoiceDeletingInfo($getWaInvoiceDeletingInfoId: ID!) {
    wawiAssist {
      getWA_InvoiceDeletingInfo(id: $getWaInvoiceDeletingInfoId) {
        paymentsToDeleteIds
        attachedOrders {
          id
          orderNo
          date
          total
        }
        deletionPossibility
      }
    }
  }
`;

export const getInvoiceData = gql`
  query getInvoiceData($id: ID!) {
    wawiAssist {
      getInvoiceData(id: $id) {
        id
        isDeleted
        linkText
        note
        datetimeOfLastEmail
        reasonForDeletion
      }
    }
  }
`;

export const deleteInvoice = gql`
  mutation DeleteWA_Invoice($deleteProps: WA_DeleteInvoiceInputs!) {
    wawiAssist {
      deleteWA_Invoice(deleteProps: $deleteProps)
    }
  }
`;

export const abacusExportInvoices = gql`
  mutation exportAbacusWA_Invoices($params: WA_ExportAbacusInvoicesInputs!) {
    wawiAssist {
      exportAbacusWA_Invoices(params: $params) {
        url
      }
    }
  }
`;

export const datevExportInvoices = gql`
  mutation ExportDatevWA_Invoices($params: WA_ExportDatevInvoicesInputs!) {
    wawiAssist {
      exportDatevWA_Invoices(params: $params) {
        url
      }
    }
  }
`;

export const initInvoiceExportPdfs = gql`
  mutation InitInvoiceExportPdfs($params: WA_InitInvoiceExportPdfsInputs!) {
    wawiAssist {
      initWA_InvoiceExportPdfs(params: $params) {
        jobId
      }
    }
  }
`;

export const getInvoiceExportPdfsInZip = gql`
  query GetInvoiceExportPdfsInZip($jobId: String!) {
    wawiAssist {
      getWA_InvoiceExportPdfsInZip(jobId: $jobId) {
        status
        url
      }
    }
  }
`;
